export default {
  // qraved-bo-order -> api/v1/order
  BO_CALCULATE_ORDER: {
    path: 'bocalculateorder',
    source: 'order'
  },
  CONSULT_ORDER: {
    path: 'consultorder',
    source: 'order'
  },
  SUBMIT_POSTPAY_ORDER: {
    path: 'submit/postpayorder',
    source: 'order'
  },
  CONSULT_OTHER_ORDER: {
    path: 'consult/otherorder',
    source: 'order'
  },
  POS_ORDER: {
    path: 'posOrder',
    source: 'order'
  },
  // qraved-bo-order-data->api/v1/data
  ORDER: {
    path: 'order',
    source: 'data'
  },
  ORDER_DETAILS: {
    path: 'orderdetails',
    source: 'data'
  },
  RAW_DATA: {
    path: 'rawdata',
    source: 'data'
  },
  CONFIGURATION: {
    path: 'configuration',
    source: 'data'
  },
  // qraved-bo-store -> api/v1/store
  STORE_INFO: {
    path: 'storeinfo',
    source: 'store'
  },
  GET_STORE_GEOFENCE: {
    path: 'getstoregeofence',
    source: 'store'
  },
  NEARST_STORE: {
    path: 'neareststore',
    source: 'store'
  },
  OUTLETLIST: {
    path: 'outletlist',
    source: 'store'
  },
  TABLES: {
    path: 'tables',
    source: 'store'
  },
  BUILDINGS: {
    path: 'buildinglist',
    source: 'store'
  },
  MENU_LIST: {
    path: 'menu/list',
    source: 'store'
  },
  // qraved-bo-export ->qra/v1/export
  SALES_SUMMARY_COUNT: {
    path: 'sales/summary/count',
    source: 'export'
  },
  SALES_SUMMARY_MENUS: {
    path: 'sales/summary/menus',
    source: 'export'
  },
  SALES_SUMMARY_EXPORT: {
    path: 'sales/summary/export',
    source: 'export'
  },
  ORDEREXPORT: {
    path: 'orderexport',
    source: 'export'
  },
  EXPORT_AUDIT: {
    path: 'exportaudit',
    source: ''
  },
  STORE_PIN: {
    path: 'pin',
    source: ''
  },
  CHECK_STORE_PIN: {
    path: 'pin/valid',
    source: ''
  },
  ORDERING_ORDER_BO_BILLING_LIST: {
    path: 'ordering/order/bo/billing/list',
    source: ''
  },
  ORDERING_ORDER_BO_GLOBAL_SETTING_DELIVERY: {
    path: 'ordering/order/bo/global_setting/delivery',
    source: ''
  },
  ORDERING_ORDER_BO_LIST_BY_MENU_ITEMS: {
    path: 'ordering/order/bo/list_by_menu_items',
    source: ''
  },
  PRINT_INTERVAL: {
    path: 'printed/interval',
    source: ''
  },
  PRINT_ORDER: {
    path: 'printed/orders',
    source: ''
  },
  GENERALDATA: {
    path: 'generaldata',
    source: ''
  },
  GLOBAL: {
    path: 'global',
    source: ''
  },
  ITEM: {
    path: 'item',
    source: ''
  },
  MENU_GROUP: {
    path: 'menuGroup',
    source: ''
  },
  MENU_GROUP_LIMIT: {
    path: 'menuGroupLimit',
    source: ''
  },
  MEMU_GROUP_SCHEDULES: {
    path: 'menu/group/schedules',
    source: ''
  },
  MEMU_GROUP_SCHEDULE: {
    path: 'menu/group/schedule',
    source: ''
  },
  MENU_ITEM: {
    path: 'menuItem',
    source: ''
  },
  MENU_ITEM_STOCK: {
    path: 'menuItem_stock',
    source: ''
  },
  MENU_ITEM_LIMIT: {
    path: 'menuItemLimit',
    source: ''
  },
  ORDERING_ORDER_BO_ASSET_BINDING_MENU_ITEMS_LINK_ORDER_TYPES: {
    path: 'ordering/order/bo/asset_binding/menu_items/link_order_types',
    source: ''
  },
  MENU_PRICE: {
    path: 'menuPrice',
    source: ''
  },
  IMEX_BO_MENU_BY_TEMPLATE: {
    path: 'imex/bo_menu/by_template',
    source: ''
  },
  IMEX_BO_CUSTOMER_BY_TEMPLATE: {
    path: 'imex/bo_customer/by_template',
    source: ''
  },
  VARIANT: {
    path: 'variant',
    source: ''
  },
  VARIANTS: {
    path: 'variants',
    source: ''
  },
  CATEGORIES: {
    path: 'categories',
    source: ''
  },
  CATEGORY: {
    path: 'category',
    source: ''
  },
  MODIFIER_ITEM: {
    path: 'modifierItem',
    source: ''
  },
  MODIFIER_PRICE: {
    path: 'modifierPrice',
    source: ''
  },
  DOWNLOAD: {
    path: 'download',
    source: ''
  },
  UPDATE_ORDER_STATUS: {
    path: 'updateorderstatus',
    source: ''
  },
  UPDATE_ORDER_DETAIL: {
    path: 'orders/:orderId/update',
    source: ''
  },
  CNACEL_ORDER: {
    path: 'cancelOrder',
    source: ''
  },
  ORDERING_ORDER_BO_ORDERS_COUNTBY: {
    path: 'ordering/order/bo/orders/countby',
    source: ''
  },
  ORDERING_ORDER_BO_STATUS_PAYMENT_SUCCESS_GROUP_BY_ORDER_TYPE: {
    path: 'ordering/order/bo/status/payment_success/group_by/order_type',
    source: ''
  },
  ORDERING_ORDER_API_STORE_MENU_ITEMS_SEARCH: {
    path: 'ordering/order/api/store/menu_items/search',
    source: ''
  },
  ORDER_MENU: {
    path: 'orderMenu',
    source: ''
  },
  OUTLET_PRICE: {
    path: 'outletPrice',
    source: ''
  },
  ORDERING_ORDER_BO_GLOBAL_CONFIG: {
    path: 'ordering/order/bo/global/config',
    source: ''
  },
  CONSULT_POSTPAY_BILL: {
    path: 'consult/postpaybill',
    source: ''
  },
  GET_CIMB_STATUS: {
    path: 'getCimbStatus',
    source: ''
  },
  GET_MID_STATUS: {
    path: 'checkOrderStatus',
    source: ''
  },
  GET_ASTRA_PAY_STATUS: {
    path: 'astrapaystatus',
    source: ''
  },
  UPDATE_BILL_STATUS: {
    path: 'updatebillstatus',
    source: ''
  },
  SALE_MENU_SCHEDULE: {
    path: 'saleMenuSchedule',
    source: ''
  },
  STORE: {
    path: 'store',
    source: ''
  },
  HOME_APP_RESTAURANT_DETAIL: {
    path: 'home/app/restaurant/detail',
    source: ''
  },
  ORDERING_ORDER_BO_STORES_LIST: {
    path: 'ordering/order/bo/stores/list',
    source: ''
  },
  ORDERING_ORDER_BO_STORES: {
    path: 'ordering/order/bo/stores',
    source: ''
  },
  ORDERING_ORDER_STORES_COUPON_LIST: {
    path: 'ordering/order/api/store/coupon/list',
    source: ''
  },
  ORDERING_ORDER_USER_ID: {
    path: `user/register/guest/create?api_key=${
      process.env.VUE_APP_QRAVED_API_KEY
    }`,
    source: ''
  },
  ORDER_TABLE: {
    path: 'orderTable',
    source: ''
  },
  STORE_DELIVERY_SCHEDULE: {
    path: 'storeDeliverySchedule',
    source: ''
  },
  STORE_GEOFENCE: {
    path: 'storeGeofence',
    source: ''
  },
  STORE_OPEN_SCHEDULE: {
    path: 'storeOpenSchedule',
    source: ''
  },
  CHANGE_ORDER_STATUS: {
    path: 'order/status',
    source: ''
  },
  CHANGE_CIMB_ORDER_STATUS: {
    path: '/order/cimb/status',
    source: ''
  },
  CHANGE_CIMB_ORDER_CALLBACK: {
    path: '/order/cimb/callback',
    source: ''
  },
  CHANGE_ORDER_PAYMENT_METHOD: {
    path: 'order/payment',
    source: ''
  },
  RECONCILE_OTTOPAY_REPORT: {
    path: 'order/ottopay/reconcile',
    source: ''
  },
  REFUND_ORDER: {
    path: 'order/refund',
    source: ''
  },
  GET_CONFIGURATION: {
    path: 'configuration',
    source: ''
  },
  STORE_CONF_LIST: {
    path: 'storeconflist',
    source: ''
  },
  MESSAGE_GROUP_LIST: {
    path: 'messagegrouplist',
    source: ''
  },
  CREATE_STORE_CONF: {
    path: 'storeconf',
    source: ''
  },
  UPDATE_CONF: {
    path: 'storeconf',
    source: ''
  },
  GET_ONE_STORE_CONF: {
    path: 'storeconf',
    source: ''
  },
  DELETE_STORE_CONF: {
    path: 'storeconf',
    source: ''
  },
  GET_PROCESSING_FEE: {
    path: 'processingFee',
    source: ''
  },
  GET_WAITING_LIST: {
    path: 'waitingList',
    source: ''
  },
  UPDATE_WAITING: {
    path: 'waiting',
    source: ''
  },
  GET_NEW_WAITING: {
    path: 'newWaiting',
    source: ''
  },
  CHECK_USER_REGISTERED: {
    path: 'ordering/order/api/user/register/check',
    source: ''
  },
  USER_DETAIL: {
    path: 'user/detail',
    source: ''
  },
  USER_REGISTER: {
    path: 'user/register',
    source: ''
  },
  USER_UPDATE_TAGGING: {
    path: 'user/tagging',
    source: ''
  },
  USER_SEARCH: {
    path: 'user/search',
    source: ''
  },
  COUPON_LIST: {
    path: 'coupon/list',
    source: ''
  },
  GLOBAL_SETTING_FEE: {
    path: 'fee/setting',
    source: ''
  },
  REVIEW_SETTINGS: {
    path: 'review/settings/list',
    source: ''
  },
  REVIEW_HANDLER: {
    path: 'review/setting',
    source: ''
  },
  REVIEWS_LIST: {
    path: 'review/list',
    source: ''
  },
  STORE_STAFF_LIST: {
    path: 'staffs',
    source: ''
  },
  STORE_STAFF: {
    path: 'staff',
    source: ''
  },
  CHECK_PIN_CODE: {
    path: 'pincode/valid',
    source: ''
  },
  POS_ORDER_INPUT: {
    path: 'orderPosOrderID',
    source: ''
  },
  // Customer Management
  OUTLET_USER: {
    path: 'outlet/user',
    source: 'store'
  },
}
